export default __webpack_public_path__ + "static/media/bscscan-logo.e7dce3c0.png";